import React from 'react';
import PropTypes from 'prop-types';

import {Commands as ModuleCommands} from 'views/module';

import {simplifyQuestions} from 'utils/user_bio';

const Skills = (props) => {
  const {caregiverBackend, caregiverBioQuestions, caregiverRn} = props;

  const caregiverBio = React.useMemo(() => {
    if (!caregiverBioQuestions?.questions) {
      return {};
    }

    return simplifyQuestions(caregiverBioQuestions.questions);
  }, [caregiverBioQuestions]);

  const commandProps = React.useMemo(() => {
    const email = caregiverBio.email;

    return {
      communicationTarget: {
        email,
        sendEmail: async (emailData, onSuccess, onError=()=>undefined) => {
          return caregiverBackend.messages.sendEmail(caregiverRn, emailData, onSuccess, onError);
        },
      },
      resources: [
        {type: 'CAREGIVER', rn: caregiverRn},
      ],
    };
  }, [caregiverBackend, caregiverBio, caregiverRn]);

  return (
    <ModuleCommands
      {...commandProps}
    />
  );
};

Skills.propTypes = {
  caregiverBackend: PropTypes.object.isRequired,
  caregiverBioQuestions: PropTypes.object.isRequired,
  caregiverRn: PropTypes.string.isRequired,
};

export default React.memo(Skills);
